import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Shield, FileText, Lock } from 'lucide-react';
import { Card } from '../components/ui/card';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-pink-800 to-purple-900 pb-8">
      {/* Header */}
      <div className="sticky top-0 bg-purple-900/80 backdrop-blur-md border-b border-white/10 px-4 py-4 z-40">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="text-white p-2">
            <ChevronLeft className="w-6 h-6" />
          </button>
          <FileText className="w-6 h-6 text-pink-300" />
          <h1 className="text-xl font-bold text-white">Conditions d'Utilisation</h1>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-4 py-6">
        <Card className="p-6 bg-white/10 backdrop-blur-md border-white/20">
          <div className="prose prose-invert max-w-none">
            <p className="text-pink-200 text-sm mb-4">Dernière mise à jour : Mars 2026</p>

            <h2 className="text-xl font-bold text-white mt-6 mb-3">1. Acceptation des Conditions</h2>
            <p className="text-pink-100 text-sm leading-relaxed mb-4">
              En accédant et en utilisant l'application Fleur de Vie, vous acceptez d'être liée par ces conditions d'utilisation. 
              Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre application.
            </p>

            <h2 className="text-xl font-bold text-white mt-6 mb-3">2. Description du Service</h2>
            <p className="text-pink-100 text-sm leading-relaxed mb-4">
              Fleur de Vie est une application éducative gratuite dédiée à la santé reproductive et au bien-être des femmes. 
              Elle propose des modules éducatifs, un suivi du cycle menstruel, une gestion de la contraception et des rappels personnalisés.
            </p>

            <h2 className="text-xl font-bold text-white mt-6 mb-3">3. Inscription et Compte</h2>
            <p className="text-pink-100 text-sm leading-relaxed mb-4">
              Pour utiliser certaines fonctionnalités, vous devez créer un compte. Vous êtes responsable de :
            </p>
            <ul className="list-disc list-inside text-pink-100 text-sm mb-4 space-y-1">
              <li>Fournir des informations exactes lors de l'inscription</li>
              <li>Maintenir la confidentialité de votre mot de passe</li>
              <li>Toutes les activités effectuées sous votre compte</li>
            </ul>

            <h2 className="text-xl font-bold text-white mt-6 mb-3">4. Utilisation Acceptable</h2>
            <p className="text-pink-100 text-sm leading-relaxed mb-4">
              Vous vous engagez à utiliser l'application de manière responsable et à ne pas :
            </p>
            <ul className="list-disc list-inside text-pink-100 text-sm mb-4 space-y-1">
              <li>Partager des contenus illégaux, offensants ou inappropriés</li>
              <li>Tenter de pirater ou compromettre la sécurité de l'application</li>
              <li>Utiliser l'application à des fins commerciales sans autorisation</li>
              <li>Créer plusieurs comptes ou usurper l'identité d'autrui</li>
            </ul>

            <h2 className="text-xl font-bold text-white mt-6 mb-3">5. Contenu Éducatif</h2>
            <p className="text-pink-100 text-sm leading-relaxed mb-4">
              Le contenu de Fleur de Vie est fourni à titre informatif et éducatif uniquement. 
              Il ne remplace pas une consultation médicale professionnelle. En cas de problème de santé, 
              consultez toujours un professionnel de santé qualifié.
            </p>

            <h2 className="text-xl font-bold text-white mt-6 mb-3">6. Propriété Intellectuelle</h2>
            <p className="text-pink-100 text-sm leading-relaxed mb-4">
              Tous les contenus de l'application (textes, images, logos, modules éducatifs) sont protégés 
              par les droits de propriété intellectuelle. Toute reproduction non autorisée est interdite.
            </p>

            <h2 className="text-xl font-bold text-white mt-6 mb-3">7. Suppression de Compte</h2>
            <p className="text-pink-100 text-sm leading-relaxed mb-4">
              Vous pouvez demander la suppression de votre compte à tout moment depuis les paramètres de votre profil. 
              La suppression entraînera l'effacement définitif de vos données personnelles conformément à notre politique de confidentialité.
            </p>

            <h2 className="text-xl font-bold text-white mt-6 mb-3">8. Modifications des Conditions</h2>
            <p className="text-pink-100 text-sm leading-relaxed mb-4">
              Nous nous réservons le droit de modifier ces conditions à tout moment. Les utilisatrices seront 
              informées des changements majeurs par notification dans l'application.
            </p>

            <h2 className="text-xl font-bold text-white mt-6 mb-3">9. Limitation de Responsabilité</h2>
            <p className="text-pink-100 text-sm leading-relaxed mb-4">
              Fleur de Vie est fournie "telle quelle". Nous ne garantissons pas que l'application sera 
              toujours disponible ou exempte d'erreurs. Nous déclinons toute responsabilité pour les 
              dommages indirects résultant de l'utilisation de l'application.
            </p>

            <h2 className="text-xl font-bold text-white mt-6 mb-3">10. Contact</h2>
            <p className="text-pink-100 text-sm leading-relaxed mb-4">
              Pour toute question concernant ces conditions d'utilisation, contactez-nous à :<br />
              <span className="text-pink-300">support@fleurde-vie.com</span>
            </p>

            <div className="mt-8 p-4 bg-pink-500/20 rounded-lg border border-pink-400/30">
              <p className="text-white text-sm">
                En utilisant Fleur de Vie, vous confirmez avoir lu, compris et accepté ces conditions d'utilisation.
              </p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default TermsOfService;
